import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useLocalStorage, useMediaQuery, useUpdateEffect } from '..';
var COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)';
function useDarkMode(defaultValue) {
  var _a;
  var isDarkOS = useMediaQuery(COLOR_SCHEME_QUERY);
  var _useLocalStorage = useLocalStorage('usehooks-ts-dark-mode', (_a = defaultValue !== null && defaultValue !== void 0 ? defaultValue : isDarkOS) !== null && _a !== void 0 ? _a : false),
    _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
    isDarkMode = _useLocalStorage2[0],
    setDarkMode = _useLocalStorage2[1];
  useUpdateEffect(function () {
    setDarkMode(isDarkOS);
  }, [isDarkOS]);
  return {
    isDarkMode: isDarkMode,
    toggle: function toggle() {
      return setDarkMode(function (prev) {
        return !prev;
      });
    },
    enable: function enable() {
      return setDarkMode(true);
    },
    disable: function disable() {
      return setDarkMode(false);
    }
  };
}
export default useDarkMode;